// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../admin/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../admin/node_modules/css-loader/dist/cjs.js??ref--9-oneOf-1-1!../../../admin/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../admin/node_modules/postcss-loader/src/index.js??ref--9-oneOf-1-2!vue-multiselect/dist/vue-multiselect.min.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, "/* Bulma Utilities */\n@media screen and (min-width: 769px) {\na[href*=\"tel:\"] {\n    cursor: default;\n    pointer-events: none;\n    color: hsl(0deg, 0%, 29%);\n}\n}\n.multiselect.error .multiselect__tags {\n  border: 1px solid red;\n}", ""]);
// Exports
module.exports = exports;
